export const CREATE_CONTEXTUAL_TEMPLATE = 'createContextualTemplate';
export const CREATE_CONTEXTUAL_WORKFLOW = 'createContextualWorkflow';
export const DELETE_CONTEXTUAL_WORKFLOW = 'deleteContextualWorkflow';
export const EXTERNAL_NAVIGATION = 'externalNavigation';
export const RELATED_WORKFLOWS_TABLE_INTERACTION = 'relatedWorkflowsTableInteraction';
export const UPDATE_CONTEXTUAL_WORKFLOW = 'updateContextualWorkflow';
export const VIEW_KNOWLEDGE_BASE_ARTICLE = 'viewKnowledgeBaseArticle';
export const VIEWED_COMPONENT = 'viewedComponent';
export const VIEWED_REFERENCE_TYPE = 'viewedReferenceType';
const TrackingEventKeys = {
  CREATE_CONTEXTUAL_TEMPLATE,
  CREATE_CONTEXTUAL_WORKFLOW,
  DELETE_CONTEXTUAL_WORKFLOW,
  EXTERNAL_NAVIGATION,
  RELATED_WORKFLOWS_TABLE_INTERACTION,
  UPDATE_CONTEXTUAL_WORKFLOW,
  VIEW_KNOWLEDGE_BASE_ARTICLE,
  VIEWED_COMPONENT,
  VIEWED_REFERENCE_TYPE
};